import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slider-view-more-button',
  templateUrl: './slider-view-more-button.component.html',
  styleUrls: ['./slider-view-more-button.component.scss'],
})
export class SliderViewMoreButtonComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
